// this is needed to have an async boundary, that ensures that shared resources are awaited when loaded on client side
import('./bootstrap');
